/* Name: handleFileUpload.tsx
* Copyright: (c) DA-Design Oy
* Creation date: 15.05.2024   (EKn)
*
* Description: 
*/

import { AxiosResponse } from 'axios';
import { BlockBlobClient } from '@azure/storage-blob';
import { Box, Button, Typography } from '@mui/material';
import { ChangeEvent, useState } from 'react';
import React from 'react';

import { convertFileToArrayBuffer } from '../lib/convert-file-to-arraybuffer';
import { sm4request } from './tokenInterceptor';

const API_SERVER = import.meta.env.VITE_API_SERVER as string;
const BLOB_SIZE_LIMIT = import.meta.env.VITE_API_BLOB_SIZE_LIMIT;
const containerName = `m-sm4-filemanager-updates-blob-container`;

type ListResponse = {
    list: string[];
    };
    
function FileUpload(props) {
    const [list, setList] = useState<string[]>([]);
    const [uploadStatus, setUploadStatus] = useState<string>('');

    function handleFileUpload() {
        convertFileToArrayBuffer(props.SelectedFile as File)
        .then((fileArrayBuffer) => {
            const DEFAULT_SIZE_LIMIT = 104857600 // 100 MB
            if (
            fileArrayBuffer === null ||
            fileArrayBuffer.byteLength < 1 ||
            /*fileArrayBuffer.byteLength > (BLOB_SIZE_LIMIT ?? DEFAULT_SIZE_LIMIT)*/
            fileArrayBuffer.byteLength > DEFAULT_SIZE_LIMIT
            ) {
            throw new Error('The selected file is empty or exceeds the 100 MB upload limit.');
            }

            const blockBlobClient = new BlockBlobClient(props.SasTokenUrl);
            return blockBlobClient.uploadData(fileArrayBuffer);
        })
        .then(() => {
            setUploadStatus('Successfully finished upload');
            return sm4request.get(`/api/list?container=${containerName}`);
        })
        .then((result: AxiosResponse<ListResponse>) => {
            // Axios response
            const { data } = result;
            const { list } = data;
            setList(list);

            console.log(list);
        })
        .catch((error: unknown) => {
            if (error instanceof Error) {
            const { message, stack } = error;
            setUploadStatus(
                `Failed to finish upload with error : ${message} ${stack || ''}`
            );
            } else {
            setUploadStatus(error as string);
            }
        });
    }

    return(
        <Box>
            {props.SasTokenUrl && (
            <Box display="block" justifyContent="left" alignItems="left" flexDirection="column"  my={4} >
                <Button variant="contained" onClick={handleFileUpload}>
                    Upload
                </Button>
                {uploadStatus && (
                    <Box my={2}>
                        <Typography variant="body2" gutterBottom>
                        {uploadStatus}
                        </Typography>
                    </Box>
                )}
            </Box>
            )}
        </Box>
    );
  };

  export default FileUpload;
